import { JSONModel } from '@/store/models/jsonModel';
import UserRelationship, { UserRelationshipJSON } from '@/store/modules/users/user-relationship';
import { SendGridEmailType } from './types';

export interface SendGridEmailJSON {
  id: number;
  msg_id: string;
  to_email?: string;
  user_id?: number;
  email_type?: string;
  subject?: string;
  status?: string;
  opens_count?: number;
  clicks_count?: number;
  last_event_time?: string;
  created_at?: string;
  updated_at?: string;
  user?: UserRelationshipJSON;
}

export default class SendGridEmail extends JSONModel<SendGridEmailJSON> {
  public id: number = 0;
  public msgId: string = '';
  public toEmail: string = '';
  public userId: number = 0;
  public emailType: SendGridEmailType = SendGridEmailType.Other;
  public subject: string = '';
  public status: string = '';
  public opensCount: number = 0;
  public clicksCount: number = 0;
  public lastEventTime: string = '';
  public createdAt: string = '';
  public updatedAt?: string;
  public user?: UserRelationship;

  public fromJSON(json: SendGridEmailJSON) {
    this.id = Number(json.id);
    this.msgId = String(json.msg_id);

    if (json.to_email) {
      this.toEmail = String(json.to_email);
    }
    if (json.user_id) {
      this.userId = Number(json.user_id);
    }
    if (json.email_type) {
      this.emailType = json.email_type as SendGridEmailType;
    }
    if (json.subject) {
      this.subject = String(json.subject);
    }
    if (json.status) {
      this.status = String(json.status);
    }
    this.opensCount = Number(json.opens_count || 0);
    this.clicksCount = Number(json.clicks_count || 0);
    if (json.last_event_time) {
      this.lastEventTime = String(json.last_event_time);
    }
    if (json.created_at) {
      this.createdAt = String(json.created_at);
    }
    if (json.updated_at) {
      this.updatedAt = String(json.updated_at);
    }
    if (json.user && json.user_id) {
      this.user = UserRelationship.fromJSON(json.user);
    }
  }
}
